import {GridOptions, GridReadyEvent} from 'ag-grid-community';
import {Nullable} from 'js/reusable/types/general';
import {getCurrencyMetaData} from 'js/tool/metaData/helper';
import number from 'js/tool/number';

export const GLOBAL_GRID_OPTIONS: GridOptions = {
	headerHeight:        42,
	rowHeight:           42,
	groupHeaderHeight:   42,
	rowBuffer:           5,
	suppressContextMenu: true,
	ensureDomOrder:      true,
	icons:               {
		sortAscending:   '<i class="fas fa-caret-up"/>',
		sortDescending:  '<i class="fas fa-caret-down"/>',
		groupExpanded:   '<i class="fas fa-angle-down fa-fw" />',
		groupContracted: '<i class="fas fa-angle-right fa-fw" />',
		groupLoading:    '<i class="fas fa-circle-notch" />',
		loading:         '<i class="fas fa-circle-notch" />',
	},
	defaultColDef: {
		enableRowGroup: true,
		enablePivot:    true,
		enableValue:    true,
		suppressMenu:   true,
		sortable:       true,
		resizable:      true,
		filter:         false,
		flex:           1,
		minWidth:       100,
	},
	tooltipShowDelay: 100,
};

export function sizeColumnsToFit(params: GridReadyEvent) {
	params.api.sizeColumnsToFit();
}

export function formatNumber(
	value: Nullable<number | string> | undefined,
	options: any,
	type: string
) {
	if (value === null || value === undefined) {
		return '-';
	}
	
	const {facebookCurrencyOffset} = getCurrencyMetaData(options.currencyTag);
	const round = facebookCurrencyOffset === 1 && (type === 'currency' || type === 'float' || type === 'integer');

	return number.formatLocale(
		typeof value === 'string' ? +value : value,
		options.decimalPlaces,
		options.decimalPoint,
		options.thousandsSep,
		options.currencyTag,
		type,
		false,
		round
	);
}
